import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, isDefaultThemeMode, accessibilityBorder } from 'core/theme';


const accessibilityBorderExtend = (props) => !isDefaultThemeMode(props) && css`
  ${accessibilityBorder};
  border-width: 2px;
`;

const accessibilityHoverInvert = (props) => {
  if (!isDefaultThemeMode(props)) {
    return css`
      &:hover {
        background-color: ${colors.text};

        & p, h1, h2, h3, h4, h5, h6 {
          color: ${colors.background};
        }

        ${({type}) => (type !== 'cover' && type !== 'video') && css`
          & > section button {
            color: ${colors.background};
          }
        `};
      }
    `;
  }
};

const CardBase = styled(Link)`
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  text-decoration: none;
  ${accessibilityBorderExtend};
  ${accessibilityHoverInvert};

  & > * {
    pointer-events: none;
    user-select: none;
  }

  ${props => !isDefaultThemeMode(props) && props.type === 'cover' && css`
    &:hover button {
      background-color: ${colors.text};
      color: ${colors.background};
    }
  `};

  @media print {
    align-items: flex-start;
    border: 2px solid ${colors.hairline};
    display: block;
    page-break-inside: avoid;

    &:after {
      margin: 0;
      padding: 16px;
    }

    & > * {
      page-break-inside: avoid;
    }
  }
`;

export default CardBase;



// WEBPACK FOOTER //
// ./src/elements/Card/styled/CardBase.js